import dayjs from "utils-lib/date"

/**
 * Takes a date and returns a string in the format of YYYY/MM/DD.
 *
 * @param {Date} date - The date to format.
 * @returns {string} A string that is formatted in the following way: "2024/04/27".
 */
export const formatCalendarDate = (date) =>
  dayjs(date).utc().format(`YYYY/MM/DD`)

/**
 * Takes a date string in the format of "MM-DD-YYYY" and returns a date string in the format of "DD-MM-YYYY".
 *
 * @param {string} date - The date string that you want to format.
 * @returns {string} A string that is formatted in the following way: `2024-04-30`.
 */
export const formatCalendarDateString = (date) => {
  const splitDate = date.split("-")
  const formattedDate = `${splitDate[2]}-${splitDate[0]}-${splitDate[1]}`

  return formattedDate
}
